import { abbreviateNumber } from 'utils/utils';

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

export const dataBar = {
  labels,
  datasets: [
    {
      label: '',
      data: [700, 500, 600, 150, 800, 200],
      backgroundColor: '#FFA726',
      barThickness: 30,
    },
  ],
};

export const dataBar6month = {
  labels,
  datasets: [
    {
      label: '',
      data: [200, 300, 400, 150, 900, 100, 600],
      backgroundColor: '#FFA726',
      barThickness: 30,
    },
  ],
};

export const dataBar1year = {
  labels,
  datasets: [
    {
      label: '',
      data: [900, 500, 200, 150, 700, 400, 433],
      backgroundColor: '#FFA726',
      barThickness: 30,
    },
  ],
};

export const revenueOptionsBar = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        display: false, // Hide x-axis ticks
      },
    },
    y: {
      display: true,
      title: {
        display: true,
        text: 'Total revenue(₹)',
        font: {
          size: 12,
          family: 'Poppins',
          weight: 500,
        },
      },
      ticks: {
        callback(value) {
          return `₹ ${abbreviateNumber(value)}`;
        },
      },
    },
  },
  plugins: {
    zoom: {
      pan: {
        enabled: true,
        mode: 'x'
    },
      zoom: {
        wheel: {
          enabled: true,
        },
        pinch: {
          enabled: true,
        },
        mode: 'x',
      },
    },
    transitions: {
      zoom: {
        animation: {
          duration: 100,
          easing: 'easeOutCubic'
        }
      }
    },
    pan: {
      enabled: true,
      mode: 'x',
    },
    legend: {
      display: false,
      // position: 'bottom',
      // labels: {
      //   usePointStyle: true,
      //   pointStyle: 'circle',
      //   padding: 20,
      //   boxWidth: 20,
      //   font: {
      //     size: 12,
      //     weight: 500,
      //     family: 'Poppins',
      //   },
      // },
    },
    title: {
      display: true,
      text: 'Revenue Split',
      align: 'start',
      font: {
        size: 18,
        weight: 400,
        family: 'Poppins',
      },
      padding: {
        bottom: 30,
      },
      color: '#282828',
    },
  },
};

export const optionsBar = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        display: false, // Hide x-axis ticks
      },
    },
    y: {
      display: true,
      title: {
        display: true,
        text: 'No. of Booking',
        font: {
          size: 12,
          family: 'Poppins',
          weight: 500,
        },
      },
    },
  },
  plugins: {
    zoom: {
      pan: {
        enabled: true,
        mode: 'x'
    },
      zoom: {
        wheel: {
          enabled: true,
        },
        pinch: {
          enabled: true,
        },
        mode: 'x',
      },
    },
    
    transitions: {
      zoom: {
        animation: {
          duration: 100,
          easing: 'easeOutCubic'
        }
      }
    },
    pan: {
      enabled: true,
      mode: 'x',
    },
    legend: {
      display: false,
      // position: 'bottom',
      // labels: {
      //   usePointStyle: true,
      //   pointStyle: 'circle',
      //   padding: 20,
      //   boxWidth: 20,
      //   font: {
      //     size: 12,
      //     weight: 500,
      //     family:'Poppins',
      //   },
      // },
    },
    title: {
      display: true,
      text: 'Booking Split',
      align: 'start',
      font: {
        size: 18,
        weight: 400,
        family: 'Poppins',
      },
      padding: {
        top: 0,
        bottom: 20,
      },
      color: '#282828',
    },
  },
};

export const revenueFilterData = [
  {
    id: 1,
    primaryText: 'Duty Type',
    isRadio: true,
    subItems: [
      { value: 'rental', list: 'Rental', key: 'DutyType' },
      { value: 'airport', list: 'Airport', key: 'DutyType' },
      { value: 'outStation', list: 'OutStation', key: 'DutyType' },
    ],
  },
  {
    id: 2,
    primaryText: 'Status',
    subItems: [
      { value: 'success', list: 'Success', key: 'Status' },
      { value: 'Pending', list: 'Pending', key: 'Status' },
    ],
  },
];

export const breadcrumbPaths = [
  { name: 'Revenue', url: '', className: 'colorBlue cursorDefault' },
];

export const customerFilterData = [
  {
    id: 1,
    primaryText: 'Duty Type',
    subItems: [
      { value: 'rental', list: 'Rental', key: 'DutyType' },
      { value: 'airport', list: 'Airport', key: 'DutyType' },
      { value: 'outStation', list: 'OutStation', key: 'DutyType' },
    ],
  },
];

export const customerBreadcrumbPaths = [
  { name: 'Report', className: 'colorGrey fontSemi' },
  {
    name: ' Corporate Customer',
    url: '',
    className: 'colorBlue cursorDefault',
  },
];

export const reportFilterOptions = (cityList,parentCompanyList,subCompanyList) =>  [
  {
    id: 2,
    name: "city",
    placeholder: "All City",
    options: cityList
  },
  {
    id: 3,
    name: "parentCompanyName",
    placeholder: "All Parent Company",
    options: parentCompanyList,
  },
  {
    id: 1,
    name: "companyName",
    placeholder: "All Company",
    options: subCompanyList
  },
  ];